import "@/styles/ActionButton.scss";

interface ActionButtonProps {
    className?: string;
    id?: string;
    label?: React.ReactNode;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

/**
 * A button for performing various actions (submit, open, close, cancel, etc)
 * @name ActionButton
 * @param className
 * @param id
 * @param label
 * @param onClick
 * @return {JSX.Element}
 * @constructor
 */
const ActionButton = ({
    className = "action-button-reg",
    id,
    label,
    onClick,
    onMouseEnter,
    onMouseLeave
}: ActionButtonProps): React.JSX.Element => {
    return (
        <button
            className={className}
            id={id}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            tabIndex={0}
            type="button"
        >
            {label}
        </button>
    );
};

export default ActionButton;
